<template>
  <div class="desc-txt">
    <p><slot name="btn"></slot></p>
    <p>{{ description }}规格：{{ width }}&times;{{ height }}</p>
    <p>{{ description }}大小：{{ file_size | smartSize }}</p>
    <p>支持类型：{{ file_format | formatType }}</p>
  </div>
</template>

<script>
export default {
  props: ['description', 'width', 'height', 'file_size', 'file_format']
}
</script>

<style></style>
